export const color = {
  primary: "#006fff",
  ligthprimary: "#f0f5ff",
  red: "tomato",
  black: "#212325",
  white: "#fff",
  green: "#0e990e",
};
